// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-checklist-edit-btn-change-position > .fi-btn-icon {
  display: block;
  padding: 5px;
  font-size: 140%;
  width: 30px;
  height: 30px;
  color: var(--fi-color-dark);
}
fi-checklist-edit-btn-change-position > .fi-btn-icon[disabled] {
  color: var(--fi-color-extra-light);
}
fi-checklist-edit-btn-change-position.size-narrow > .fi-btn-icon {
  font-size: 140%;
  padding-top: 0;
  padding-bottom: 0;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist/edit/btn-change-position/btn-change-position.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AAAR;AAEQ;EACI,kCAAA;AAAZ;AAKQ;EACI,eAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AAHZ","sourcesContent":["fi-checklist-edit-btn-change-position {\r\n    > .fi-btn-icon {\r\n        display: block;\r\n        padding: 5px;\r\n        font-size: 140%;\r\n        width: 30px;\r\n        height: 30px;\r\n        color: var(--fi-color-dark);\r\n\r\n        &[disabled] {\r\n            color: var(--fi-color-extra-light);\r\n        }\r\n    }\r\n\r\n    &.size-narrow {\r\n        > .fi-btn-icon {\r\n            font-size: 140%;\r\n            padding-top: 0;\r\n            padding-bottom: 0;\r\n            height: 20px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
